import { Temporal } from '@js-temporal/polyfill';
import { createDateTimeInstant } from './createDateTimeInstant';
import { DateParts, DateTimeParts, TimeParts } from '../../../types';
import { START_OF_DAY_TIME_PARTS } from '../../../constants/timeConstants';

type CreateInstantFn = (dateParts: DateParts) => (timeParts: TimeParts) => Temporal.Instant | undefined;
type CreateImmediateInstantFn = (datetimeParts: DateTimeParts) => Temporal.Instant | undefined;
type CreateStartOfDayFn = (dateParts: DateParts) => Temporal.Instant | undefined;

interface InstantGenerators {
  create: CreateInstantFn;
  startOfDay: CreateStartOfDayFn;
  withTime: CreateImmediateInstantFn;
}

export function createInstantGenerators(timeZone: string): InstantGenerators & { timeZone: string } {
  const create = createDateTimeInstant(timeZone);

  const startOfDay: CreateStartOfDayFn = dateParts => create(dateParts)(START_OF_DAY_TIME_PARTS);

  const withTime: CreateImmediateInstantFn = dateTimeParts => {
    const { year, month, day, hours, minutes, seconds, milliseconds } = dateTimeParts;
    const dateParts: DateParts = { year, month, day };
    const timeParts: TimeParts = { hours, minutes, seconds, milliseconds };

    return create(dateParts)(timeParts);
  };

  return {
    create,
    startOfDay,
    withTime,
    timeZone,
  };
}
